import { PaymentConfigCategory } from '../../models/paymentConfig';
import client from '../httpclient';

const getPaymentCategories = (protocolId: string):
Promise<PaymentConfigCategory[]> => client
  .get(`/re/v1/protocol/${protocolId}/category`);

export default getPaymentCategories;
